import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/ServiceAmount.css";
import { useTranslation } from "react-i18next";
import PurchasePopup from "./PurchasePopup";
import PlanDetails from "../services/PlanData"; // Comment out dynamic import
import { useLanguage } from "./../common/LanguageContext";
import AutoDebitConfirmationPopup from "./AutoDebitConfirmationPopup"; // New popup component
import useAuth from "../hooks/useAuth"; // Import the useAuth hook
import AutoDebitUpdate from "../services/AutoDebitUpdate"; // Import the auto debit update
const AutoDebitSuccessPopup = ({ onClose }) => {
  const { t } = useTranslation(); // Use translation hook

  return (
    <div className="auto-debit-popup-overlay">
      <div className="auto-debit-success-popup">
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              backgroundColor: "#4CAF50",
              color: "white",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "8px",
            }}
          >
            &#10004;
          </div>
          <h4 style={{ marginTop: "10px" }}>{t("autoDebitSuccessTitle")}</h4>
          <button
            className="cross"
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#555",
              fontSize: "16px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
          >
            &#10006;
          </button>
        </div>
        <p
          style={{
            fontSize: "16px",
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
            marginTop: "40px",
          }}
        >
          {t("autoDebitSuccessMessage")}
        </p>
      </div>
    </div>
  );
};

// New Alert Popup Component
const AlertPopup = ({ message, onClose }) => {
  const { t } = useTranslation(); // Use translation hook

  return (
    <div
      className="auto-debit-popup-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)" /* Dimmed background */,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)" /* Background blur */,
      }}
    >
      <div
        className="auto-debit-confirmation-popup"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "12px",
          width: "350px",
          position: "relative",
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)" /* Adds depth */,
          textAlign: "center",
        }}
      >
        <h4 style={{ marginBottom: "15px", fontWeight: "bold", color: "#333" }}>
          ⚠ {t("alert")}
        </h4>
        <p style={{ fontSize: "16px", color: "#555" }}>
          <strong>{t("disableAutoDebitMessage")}</strong>
        </p>

        <div
          className="confirmation-buttons"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <button
            className="cancel-btn"
            onClick={onClose}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              boxShadow:
                "0px 4px 10px rgba(0, 123, 255, 0.3)" /* Adds button effect */,
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            {t("okButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

const ServiceAmount = ({ serviceName, svcName }) => {
  const { t } = useTranslation();
  const [selectedPlan, setSelectedPlan] = useState("PRO PLAN");
  const [showPopup, setShowPopup] = useState(false);
  const [popupPlan, setPopupPlan] = useState(null);
  const { language } = useLanguage();
  const [plans, setPlans] = useState([]);
  const [autoDebitActivePlan, setAutoDebitActivePlan] = useState(null);
  const [showAutoDebitPopup, setShowAutoDebitPopup] = useState(false);
  const [pendingAutoDebitPlanId, setPendingAutoDebitPlanId] = useState(null);
  const [showAutoDebitSuccess, setShowAutoDebitSuccess] = useState(false); // State for the success popup
  //const { role } = useAuth(); // Get the role from the useAuth hook
  const [showAlertPopup, setShowAlertPopup] = useState(false); // State for the alert popup
  const [alertMessage, setAlertMessage] = useState(""); // State for the alert message
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOption, setSortOption] = useState(null);
  const [serviceData, setServiceData] = useState(null);
  const role = sessionStorage.getItem("role");
  //const role="MASS_ADMIN";

  // Static plan data for testing
  /*const staticPlans = [
    {
      planName: "BASIC PLAN",
      planTotalCost: "199",
      planTotalWhatsApp: "100",
      planStatus: "Active",
      planTotalCallMinutes: "50",
      planId: "basic123",
    },
    {
      planName: "PRO PLAN",
      planTotalCost: "499",
      planTotalWhatsApp: "500",
      planStatus: "Active",
      planTotalCallMinutes: "300",
      planId: "pro456",
    },
    {
      planName: "BASIC",
      planTotalCost: "999",
      planTotalWhatsApp: "300",
      planStatus: "Active",
      planTotalCallMinutes: "200",
      planId: "pro656",
    },
  ];*/

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const responseData = await PlanDetails.planDetails(
          `${language}`,
          serviceName
        );

        setPlans(responseData.planList);
        setServiceData({
          serviceId: responseData.serviceId,
          serviceName: responseData.serviceName,
        });
      } catch (error) {
        console.error("Error fetching service plans:", error);
      }
    };

    fetchPlans();
    // For static testing:
    //setPlans(staticPlans);
  }, [language]);

  //addedd//
  useEffect(() => {
    if (plans.length > 0) {
      const active = plans.find((p) => p.autoDebitEnabledForDealer === true);
      if (active) {
        setAutoDebitActivePlan(active.planId);
      }
    }
  }, [plans]);
  //addedd//

  const handleAddService = (plan) => {
    setSelectedPlan(plan.planName);
    setPopupPlan(plan);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupPlan(null);
  };

  const handleAutoDebitToggle = async (planId) => {
    if (autoDebitActivePlan && autoDebitActivePlan !== planId) {
      setAlertMessage(
        "Disable Auto Debit for the current plan before enabling a new one."
      );
      setShowAlertPopup(true);
      return;
    }

    // If auto-debit is active for this plan, we want to disable it
    if (autoDebitActivePlan === planId) {
      setPendingAutoDebitPlanId(null); // No pending action
      try {
        await AutoDebitUpdate.updateAutoDebit(serviceName, planId, false);
        setAutoDebitActivePlan(null); // Disable auto-debit only after the backend confirms
      } catch (error) {
        console.log("error updating auto debit details:", error);
        setAlertMessage(
          "Failed to disable Auto Debit. Please try again."
        );
        setShowAlertPopup(true);
      }
      // Optionally, you might want to show a "Auto Debit Disabled" message
      return;
    }

    // If auto-debit is not active, we want to enable it
    setPendingAutoDebitPlanId(planId);
    setShowAutoDebitPopup(true);
  };

  const handleAutoDebitConfirmation = async (confirm) => {
    if (confirm) {
      try {
        await AutoDebitUpdate.updateAutoDebit(
          serviceName,
          pendingAutoDebitPlanId,
          true
        );
        setAutoDebitActivePlan(pendingAutoDebitPlanId);
        setShowAutoDebitSuccess(true); // Show the success popup only after the backend confirms
      } catch (error) {
        console.log("error updating auto debit details:", error);
        setAlertMessage(
          "Failed to enable Auto Debit. Please try again."
        );
        setShowAlertPopup(true);
      }
    }
    setShowAutoDebitPopup(false);
    setPendingAutoDebitPlanId(null);
  };

  const closeAutoDebitSuccess = () => {
    setShowAutoDebitSuccess(false);
  };

  const closeAlertPopup = () => {
    setShowAlertPopup(false);
    setAlertMessage("");
  };

  const toggleFilter = () => {
    setFilterOpen((prev) => !prev);
  };

  const handleSort = (option, order) => {
    setSortOption(`${option}-${order}`);
    let sortedPlans = [...plans];
    switch (option) {
      case "cost":
        sortedPlans.sort((a, b) => {
          const costA = parseFloat(a.planCost) || 0;
          const costB = parseFloat(b.planCost) || 0;
          return order === "asc" ? costA - costB : costB - costA;
        });
        break;
      case "minutes":
        sortedPlans.sort((a, b) => {
          const minutesA = parseInt(a.planCallMinutes) || 0;
          const minutesB = parseInt(b.planCallMinutes) || 0;
          return order === "asc" ? minutesA - minutesB : minutesB - minutesA;
        });
        break;
      case "chats":
        sortedPlans.sort((a, b) => {
          const chatsA = parseInt(a.planTotalChats) || 0;
          const chatsB = parseInt(b.planTotalChats) || 0;
          return order === "asc" ? chatsA - chatsB : chatsB - chatsA;
        });
        break;
      default:
        break;
    }
    setPlans(sortedPlans);
    setFilterOpen(false);
  };


  return (
    <div className="container mt-4">
      <div className="service-plans-header">
        <p>{t("service_amount_title", { count: plans.length })}</p>
        <div
          className="dropdown"
          onMouseEnter={() => setFilterOpen(true)}
          onMouseLeave={() => setFilterOpen(false)}
        >
          <button className="filter-btn dropdown-toggle">{t("sorting")}</button>
          {filterOpen && (
            <div className="dropdown-menu show">
              <button onClick={() => handleSort("cost", "asc")}>
                {t("cost_low_to_high")}
              </button>
              <button onClick={() => handleSort("cost", "desc")}>
                {t("cost_high_to_low")}
              </button>
              <button onClick={() => handleSort("minutes", "asc")}>
                {t("minutes_low_to_high")}
              </button>
              <button onClick={() => handleSort("minutes", "desc")}>
                {t("minutes_high_to_low")}
              </button>
              <button onClick={() => handleSort("chats", "asc")}>
                {t("chats_low_to_high")}
              </button>
              <button onClick={() => handleSort("chats", "desc")}>
                {t("chats_high_to_low")}
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="plans-list">
        {plans.map((plan, index) => (
          <div key={index} className="plan-row">
            <div
              className="plan-container"
              onClick={() => {
                if (role === "MASS_ADMIN") {
                  setSelectedPlan(plan.planName);
                }
              }}
            >
              <div className="plan-content">
                {role === "MASS_ADMIN" ? (
                  <>
                    <input
                      type="radio"
                      name="plan"
                      className="plan-radio"
                      checked={selectedPlan === plan.planName}
                      readOnly
                    />
                    <div className="plan-details">
                      <h6 className="plan-title">{plan.planName}</h6>
                      <div className="plan-values">
                        <div className="plan-item">
                          <p className="plan-value">₹{plan.planCost}</p>
                          <p className="plan-label">{t("plan_cost")}</p>
                        </div>
                        <div className="plan-item">
                          <p className="plan-value">{plan.planCallMinutes}</p>
                          <p className="plan-label">{t("total_minutes")}</p>
                        </div>
                        <div className="plan-item">
                          <p className="plan-value">{plan.planTotalChats}</p>
                          <p className="plan-label">{t("whatsapp_chats")}</p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="plan-details">
                    <h6 className="plan-title">{plan.planName}</h6>
                    <div className="plan-values">
                      <div className="plan-item">
                        <p className="plan-value">₹{plan.planCost}</p>
                        <p className="plan-label">{t("plan_cost")}</p>
                      </div>
                      <div className="plan-item">
                        <p className="plan-value">{plan.planCallMinutes}</p>
                        <p className="plan-label">{t("total_minutes")}</p>
                      </div>
                      <div className="plan-item">
                        <p className="plan-value">{plan.planTotalChats}</p>
                        <p className="plan-label">{t("whatsapp_chats")}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="button-container">
              {role === "MASS_ADMIN" && (
                <>
                  <button
                    className="add-btn"
                    onClick={() => handleAddService(plan)}
                  >
                    {t("add_service")}
                  </button>
                  <div className="auto-debit-toggle">
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={autoDebitActivePlan === plan.planId}
                        onChange={() => handleAutoDebitToggle(plan.planId)}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span className="auto-debit-text">{t("auto_debit")}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      {showPopup && popupPlan && (
        <PurchasePopup
          onClose={closePopup}
          selectedPlan={popupPlan}
          serviceId={serviceData?.serviceId} //  correct id from backend
          serviceName={svcName}
          autoDebitStatus={autoDebitActivePlan === null || autoDebitActivePlan === popupPlan.planId} // default true; false only if dealer enabled auto debit on a different plan
        />
      )}

      {showAutoDebitPopup && (
        <AutoDebitConfirmationPopup
          onConfirm={() => handleAutoDebitConfirmation(true)}
          onCancel={() => handleAutoDebitConfirmation(false)}
        />
      )}

      {showAutoDebitSuccess && (
        <AutoDebitSuccessPopup onClose={closeAutoDebitSuccess} />
      )}

      {showAlertPopup && (
        <AlertPopup message={alertMessage} onClose={closeAlertPopup} />
      )}
    </div>
  );
};

export default ServiceAmount;
